import { Box, Skeleton, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import * as S from '../styles';

interface RenderCreditInfoProps {
  remaining: number | undefined;
  isLoading: boolean;
}

export const RenderCreditInfo = ({
  remaining,
  isLoading,
}: RenderCreditInfoProps) => {
  if (isLoading || !remaining) {
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      gap="5px"
    >
      <Skeleton variant="rectangular" width="40px" height="40px" />
      <Skeleton variant="rectangular" width="150px" height="24px" />
    </Box>;
  }

  return (
    <S.BigNumbers>
      {isLoading ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="space-between"
          gap="5px"
        >
          <Skeleton variant="rectangular" width="40px" height="40px" />
          <Skeleton variant="rectangular" width="150px" height="24px" />
        </Box>
      ) : (
        <>
          <Typography variant="h4">{remaining}</Typography>
          <S.BigNumbersLabel>
            <FormattedMessage id="CAREMATRIXCPTC.SESSIONS.REMAINING" />
          </S.BigNumbersLabel>
        </>
      )}
    </S.BigNumbers>
  );
};
